import { useAuth } from "@ibcos/ui-components/dist/components/Hooks/useAuth/AuthProvider";
import { useEffect } from "react";
import LoadingSpinner from "../components/LoadingSpinner";
import DealershipUserAPI from "../modules/dealer/API/DealershipUserAPI";

const Signout: React.FC = () => {
    const { user, logout } = useAuth();

    localStorage.setItem("logout-event", "logout " + new Date().toISOString());

    // Fallback: redirect after 5 seconds if user/logout_url never loads
    useEffect(() => {
        const timeout = setTimeout(() => {
            if (!user?.logout_url) {
                window.location.href = "/signout-redirect";
            }
        }, 3000);
        return () => clearTimeout(timeout);
    }, [user?.logout_url]);

    useEffect(() => {
        if (!user?.logout_url) return; // Wait until user and logout_url are available

        const dealershipId = user.dealership_id;
        const doLogout = async () => {
            try {
                if (dealershipId) {
                    const response =
                        await DealershipUserAPI.GetDealershipUrlById(
                            dealershipId
                        );
                    const responseData = response.data.data;

                    localStorage.setItem("dealershipUrl", responseData);
                }
            } catch (e) {
                console.error("Error fetching dealership URL:", e);
            }

            try {
                logout();
            } catch (e) {
                console.error("Error during logout process:", e);
                window.location.href = `/signout-redirect`;
            }
            const logoutUrl: string = `${import.meta.env.VITE_BFF_PROXY}${
                user.logout_url
            }`;
            window.location.href = logoutUrl;
        };

        doLogout();
        // eslint-disable-next-line
    }, [user?.logout_url]);

    return <LoadingSpinner />;
};

export default Signout;
